<template>
  <div>
    <page-title>{{ currentForm.current_version.title }}</page-title>
    <loading v-if="loading" />
    <section-block class="c-container" v-else header-hidden>
      <template slot="header"> </template>
      <loading v-if="loading" />
      <div
        v-if="
          currentForm.private &&
            (currentForm.created_user.id !== userId && !userInvited)
        "
      >
        <h1>E-Form is private</h1>

        <p>You are not able to view this e-form</p>
      </div>
      <form-builder-form :form="currentForm" v-else />
    </section-block>
  </div>
</template>

<script>
import FormBuilderForm from "@/components/FormBuilderForm";
import { mapState } from "vuex";
export default {
  methods: {
    getBaseResp(elems) {
      let respObj = {};
      elems.elements.forEach((elem) => {
        respObj[elem.properties.label] = "";
      });
      return respObj;
    },
  },
  data() {
    return {
      submitted: false,
      loading: true,
    };
  },
  async created() {
    // this.$router;
    const formUrl = `/${this.$route.params.pathMatch}`;

    await this.$store.dispatch("Forms/retrieveByUrl", formUrl);
    this.loading = false;
  },
  components: {
    FormBuilderForm,
  },
  computed: {
    ...mapState("Forms", ["currentForm"]),
     userInvited() {
      if (!this.currentForm.users) {
        return false;
      }
      const users = this.currentForm.users.filter(
        (user) => user.id == this.$store.state.auth.currentUser.id
      );

      return users && users.length;
    },
    userId() {
      if (!this.$store.state.auth.currentUser.id) {
        this.$store.dispatch("auth/listCurrentUser").then((resp) => {
          return this.$store.state.auth.currentUser.id;
        });
      } else {
        return this.$store.state.auth.currentUser.id;
      }
    },
  },
};
</script>
